import { useFeature } from "src/feature/useFeature";
import { useState } from "react";
import type { JSX } from "react";
import { KoddiDestinationBranding } from "../../Koddi/KoddiDestinationBranding";
import { TwInlineAdWrapper } from "../InlineAdStyles";
import { InlineSerpGamAd } from "./InlineSerpGamAd";

export type InlineSerpAd = {
  setHasAd: React.Dispatch<React.SetStateAction<boolean>>;
};

export function InlineSerpAd() {
  const [hasAd, setHasAd] = useState(false);
  const isKoddiAd = useFeature("KoddiDestinationBranding");

  const Ad: (props: InlineSerpAd) => JSX.Element | undefined = isKoddiAd
    ? KoddiDestinationBranding
    : InlineSerpGamAd;

  return (
    <TwInlineAdWrapper hasAd={hasAd}>
      <Ad setHasAd={setHasAd} />
    </TwInlineAdWrapper>
  );
}
